import { axiosRubyClient as api } from '@/util/axios/axiosClient';

export type ClientSession = {
  id: number;
  worker_id: number;
  platform: 'ios' | 'android';
  binary_version: string;
  ota_hash: string;
  first_seen_at: string;
  last_seen_at: string;
};

export type Pagination = {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
};

export type ClientSessionListResponse = {
  success: boolean;
  data: ClientSession[];
  pagination: Pagination;
};

export async function fetchFleetClientSessions(params: {
  page?: number;
  per_page?: number;
  platform?: string;
  binary_version?: string;
}): Promise<ClientSessionListResponse> {
  const res = await api.get<ClientSessionListResponse>(
    '/api/admin/client_sessions',
    { params },
  );
  return res.data;
}

export async function fetchWorkerClientSessions(
  workerId: number,
): Promise<ClientSessionListResponse> {
  const res = await api.get<ClientSessionListResponse>(
    `/api/admin/workers/${workerId}/client_sessions`,
  );
  return res.data;
}

export type ClientSessionHashStat = {
  ota_hash: string;
  worker_count: number;
  latest_seen_at: string;
};

export type ClientSessionHashStatsResponse = {
  success: boolean;
  data: ClientSessionHashStat[];
};

export async function fetchClientSessionHashStats(): Promise<ClientSessionHashStatsResponse> {
  const res = await api.get<ClientSessionHashStatsResponse>(
    '/api/admin/client_sessions/hash_stats',
  );
  return res.data;
}
